module.exports = __webpack_public_path__ + "img/4.33de9e1d.png";